import * as React from "react";
import { useEffect } from "react";
import { Grid, IconButton, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Title from "./Title";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import TableBody from "@mui/material/TableBody";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { extractUserInfoFromToken, getLocalStorageSAMLToken } from "../utils";
import {
  filterBulkReport,
  getBulkReport,
  sortBulkExports,
} from "../redux/dynamo_db/actions";
import { downloadBulkResult } from "../redux/global/reducer";

export default function BulkReport(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [filterBatchType, setFilterBatchType] = React.useState([]);
  const [filterStatus, setFilterStatus] = React.useState([]);

  const handleGetBulkReport = async () => {
    let queryObject = {};
    const saml_token = getLocalStorageSAMLToken();
    const infoToken = extractUserInfoFromToken(saml_token);
    queryObject.request_user = infoToken.username;
    await dispatch(getBulkReport(queryObject));
    dispatch(sortBulkExports(sortParameter, sortDirection));
  };

  const handleExecuteFilter = () => {
    let filterObject = {};
    if (filterBatchType?.length > 0) {
      filterObject.batchTypes = [filterBatchType];
    }
    if (filterStatus?.length > 0) {
      filterObject.status = [filterStatus];
    }
    dispatch(filterBulkReport(filterObject));
  };

  useEffect(() => {
    handleExecuteFilter();
  }, [filterBatchType, filterStatus]);

  React.useEffect(() => {
    handleGetBulkReport();
  }, []);

  const [sortDirection, setSortDirection] = React.useState("descending");
  const [sortParameter, setSortParameter] = React.useState("start_time");

  const handleSortBulkExports = (parameter) => {
    let direction = "ascending";
    if (sortParameter === parameter) {
      direction = sortDirection === "ascending" ? "descending" : "ascending";
    }
    setSortParameter(parameter);
    setSortDirection(direction);
    dispatch(sortBulkExports(parameter, direction));
  };
  const bulkReports = useSelector((state) => {
    if (state.bulkReports) {
      return state.filteredBulkReports.map((report) => {
        return {
          sk: report.SK,
          status: report.status,
          total_data: report.total_data,
          success_data: report.success_data,
          url: report.url,
          errors: report.errors,
          start_time: report.start_time,
          end_time: report.end_time,
          process_time: report.process_time,
          batch_type: report.batch_type,
          input_file: report.input_file,
        };
      });
    } else return [];
  });
  const handleDownload = async (url, filename) => {
    try {
      // Fetch the file from the URL
      const response = await fetch(url);
      const blob = await response.blob();
      downloadBulkResult(blob, filename);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };
  return (
    <React.Fragment>
      <Button
        variant="contained"
        color="primary"
        onClick={handleGetBulkReport}
        style={{ margin: "20px 0" }}
      >
        Reload
      </Button>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Batch type"
                    variant="standard"
                    onChange={(e) => {
                      setFilterBatchType(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortBulkExports("batch_type")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "batch_type" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "batch_type" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Status"
                    variant="standard"
                    onChange={(e) => {
                      setFilterStatus(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortBulkExports("status")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "status" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "status" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>Start Time</Grid>
                <Grid item onClick={() => handleSortBulkExports("start_time")}>
                  {sortDirection === "ascending" &&
                  sortParameter === "start_time" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "start_time" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>End time</Grid>
                <Grid item onClick={() => handleSortBulkExports("end_time")}>
                  {sortDirection === "ascending" &&
                  sortParameter === "end_time" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "end_time" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>Process time</Grid>
                <Grid
                  item
                  onClick={() => handleSortBulkExports("process_time")}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "process_time" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "process_time" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>Total data</Grid>
                <Grid item onClick={() => handleSortBulkExports("total_data")}>
                  {sortDirection === "ascending" &&
                  sortParameter === "total_data" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "total_data" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>Success count</Grid>
                <Grid
                  item
                  onClick={() => handleSortBulkExports("success_data")}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "success_data" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "success_data" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>Errors count</Grid>
                <Grid item onClick={() => handleSortBulkExports("errors_data")}>
                  {sortDirection === "ascending" &&
                  sortParameter === "errors_data" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "errors_data" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>File link</Grid>
              </Grid>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {bulkReports.map((row, i) => (
            <React.Fragment key={row?.sk + i}>
              <TableRow
                hover
                style={{
                  cursor: "pointer",
                }}
              >
                <TableCell>{row?.batch_type}</TableCell>
                <TableCell>{row?.status}</TableCell>
                <TableCell>{row?.start_time}</TableCell>
                <TableCell>{row?.end_time}</TableCell>
                <TableCell>{row?.process_time}</TableCell>
                <TableCell>{row?.total_data}</TableCell>
                <TableCell>{row?.success_data}</TableCell>
                <TableCell>{row?.errors}</TableCell>
                <TableCell>
                  {row?.url && (
                    <IconButton
                      onClick={() => handleDownload(row.url, row.input_file)}
                    >
                      <FileDownloadIcon />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </React.Fragment>
  );
}
